import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
export default class PasatiemposLeaderboard extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "selectedFilter", 'global');
    _defineProperty(this, "items", []);
    _defineProperty(this, "currentUserEntry", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const attrs = vnode && vnode.attrs || this.attrs || {};
    const initFilter = attrs.initialFilter || attrs.filter;
    if (initFilter) {
      this.selectedFilter = initFilter;
    }
    this.fetchLeaderboard();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const attrs = vnode && vnode.attrs || this.attrs || {};
    const nextFilter = attrs.initialFilter || attrs.filter;
    if (nextFilter && nextFilter !== this.selectedFilter) {
      this.selectedFilter = nextFilter;
      this.fetchLeaderboard();
    }
  }
  setFilter(filter) {
    this.selectedFilter = filter;
    this.fetchLeaderboard();
  }
  fetchLeaderboard() {
    this.loading = true;
    let game = 'all';
    let level = 'all';
    if (this.selectedFilter === 'global') {
      game = 'all';
      level = 'all';
    } else if (this.selectedFilter === 'quien_dijo') {
      game = 'quien_dijo';
      level = '1';
    } else if (this.selectedFilter === 'lehoidle') {
      game = 'lehoidle';
      level = 'all';
    } else if (this.selectedFilter === 'nor_da_lehoia') {
      game = 'nor_da_lehoia';
      level = 'all';
    } else if (this.selectedFilter === 'bolilla_retro') {
      game = 'bolilla_retro';
      level = 'all';
    } else if (this.selectedFilter === 'bolilla_retro_survival') {
      game = 'bolilla_retro_survival';
      level = '1';
    } else if (this.selectedFilter === 'anagrams_all') {
      game = 'anagrams';
      level = 'all';
    } else if (this.selectedFilter === 'anagrams_1') {
      game = 'anagrams';
      level = '1';
    } else if (this.selectedFilter === 'anagrams_2') {
      game = 'anagrams';
      level = '2';
    } else if (this.selectedFilter === 'anagrams_3') {
      game = 'anagrams';
      level = '3';
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/games/leaderboard?game=".concat(game, "&level=").concat(level)
    }).then(response => {
      this.items = response.items || [];
      this.currentUserEntry = response.current_user || null;
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      m.redraw();
    });
  }
  formatAvatarUrl(url) {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
      return url;
    }
    return "/assets/avatars/".concat(url);
  }
  view(vnode) {
    const attrs = vnode && vnode.attrs || this.attrs || {};
    const hideFilters = Boolean(attrs.hideFilters);
    const compact = Boolean(attrs.compact);
    const maxItems = attrs.maxItems ? parseInt(attrs.maxItems, 10) : 0;
    const displayItems = maxItems > 0 ? this.items.slice(0, maxItems) : this.items;
    const isGlobal = this.selectedFilter === 'global';
    return m("div", {
      className: "pasatiempos-leaderboard ".concat(compact ? 'is-compact' : '')
    }, !hideFilters && m("div", {
      className: "leaderboard-filters"
    }, m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'global' ? 'active' : ''),
      onclick: () => this.setFilter('global')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83C\uDFC6 Ranking Global Pasatiempos"), m("span", {
      className: "filter-label-short"
    }, "\uD83C\uDFC6 Global")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'quien_dijo' ? 'active' : ''),
      onclick: () => this.setFilter('quien_dijo')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83D\uDCAC \xBFQui\xE9n dijo...? (Racha)"), m("span", {
      className: "filter-label-short"
    }, "\uD83D\uDCAC \xBFQui\xE9n dijo?")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'lehoidle' ? 'active' : ''),
      onclick: () => this.setFilter('lehoidle')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83C\uDFAF Lehoidle"), m("span", {
      className: "filter-label-short"
    }, "\uD83C\uDFAF Lehoidle")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'nor_da_lehoia' ? 'active' : ''),
      onclick: () => this.setFilter('nor_da_lehoia')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83E\uDD81 Nor da Lehoia?"), m("span", {
      className: "filter-label-short"
    }, "\uD83E\uDD81 Nor da?")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'bolilla_retro' ? 'active' : ''),
      onclick: () => this.setFilter('bolilla_retro')
    }, m("span", {
      className: "filter-label-full"
    }, "\u26BD Bolilla Retro (Niveles)"), m("span", {
      className: "filter-label-short"
    }, "\u26BD Bolilla")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'bolilla_retro_survival' ? 'active' : ''),
      onclick: () => this.setFilter('bolilla_retro_survival')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83E\uDD81 Muerte S\xFAbita"), m("span", {
      className: "filter-label-short"
    }, "\uD83E\uDD81 Muerte S\xFAbita")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'anagrams_all' ? 'active' : ''),
      onclick: () => this.setFilter('anagrams_all')
    }, m("span", {
      className: "filter-label-full"
    }, "\uD83D\uDD24 Anagramas (Total)"), m("span", {
      className: "filter-label-short"
    }, "\uD83D\uDD24 Anagramas")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'anagrams_1' ? 'active' : ''),
      onclick: () => this.setFilter('anagrams_1')
    }, m("span", {
      className: "filter-label-full"
    }, "Nivel 1 (1\xBA Masc)"), m("span", {
      className: "filter-label-short"
    }, "Nivel 1")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'anagrams_2' ? 'active' : ''),
      onclick: () => this.setFilter('anagrams_2')
    }, m("span", {
      className: "filter-label-full"
    }, "Nivel 2 (Masc + Fem)"), m("span", {
      className: "filter-label-short"
    }, "Nivel 2")), m("button", {
      type: "button",
      className: "filter-btn ".concat(this.selectedFilter === 'anagrams_3' ? 'active' : ''),
      onclick: () => this.setFilter('anagrams_3')
    }, m("span", {
      className: "filter-label-full"
    }, "Nivel 3 (Lezama)"), m("span", {
      className: "filter-label-short"
    }, "Nivel 3"))), this.loading ? m("div", {
      style: {
        textAlign: 'center',
        padding: compact ? '20px 0' : '40px 0'
      }
    }, m(LoadingIndicator, null)) : displayItems.length === 0 ? m("div", {
      style: {
        textAlign: 'center',
        padding: compact ? '20px 0' : '40px 0',
        color: '#64748b',
        fontSize: '14px'
      }
    }, "A\xFAn no hay puntuaciones registradas en este nivel. \xA1S\xE9 el primero en jugar!") : m("div", {
      className: "leaderboard-table-wrapper ".concat(isGlobal ? 'is-global' : '')
    }, m("table", null, m("thead", null, m("tr", null, m("th", {
      className: "rank-col"
    }, "#"), m("th", {
      className: "user-th"
    }, "Forero"), !isGlobal && m("th", {
      className: "time-col"
    }, "Tiempo"), m("th", {
      className: "attempts-col"
    }, "Partidas"), m("th", {
      className: "score-col"
    }, this.selectedFilter === 'bolilla_retro_survival' || this.selectedFilter === 'quien_dijo' ? 'Racha Máx' : 'Puntos'))), m("tbody", null, displayItems.map(row => {
      const isCurrentUser = app.session.user && intval(app.session.user.id()) === row.user_id;
      const avatarSrc = this.formatAvatarUrl(row.avatar_url);
      const initial = (row.username || '?')[0].toUpperCase();
      return m("tr", {
        key: row.user_id,
        className: isCurrentUser ? 'current-user-row' : ''
      }, m("td", {
        className: "rank-col"
      }, row.rank === 1 ? '🥇' : row.rank === 2 ? '🥈' : row.rank === 3 ? '🥉' : row.rank), m("td", {
        className: "user-td"
      }, m("div", {
        className: "user-col"
      }, avatarSrc ? m("img", {
        src: avatarSrc,
        className: "avatar",
        alt: row.username,
        onerror: e => {
          const target = e == null ? void 0 : e.target;
          if (target) {
            target.style.display = 'none';
            if (target.nextElementSibling) {
              target.nextElementSibling.style.display = 'inline-flex';
            }
          }
        }
      }) : null, m("span", {
        className: "avatar avatar--default",
        style: {
          display: avatarSrc ? 'none' : 'inline-flex'
        }
      }, initial), m(Link, {
        href: "/u/".concat(row.username),
        className: "username-link"
      }, m("strong", null, row.username)))), !isGlobal && m("td", {
        className: "time-col"
      }, row.best_time_seconds ? "".concat(row.best_time_seconds, "s") : row.total_time ? "".concat(row.total_time, "s") : '-'), m("td", {
        className: "attempts-col"
      }, row.attempts_count || row.total_attempts || 1), m("td", {
        className: "score-col"
      }, this.selectedFilter === 'bolilla_retro_survival' ? "Ronda ".concat(row.high_score || 0) : this.selectedFilter === 'quien_dijo' ? "".concat(row.high_score || 0, " aciertos") : "".concat(row.high_score || row.total_score || 0, " pts")));
    })))));
  }
}
function intval(val) {
  return parseInt(val, 10) || 0;
}
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/PasatiemposLeaderboard', PasatiemposLeaderboard);